import React, { createContext, useState, useContext, useEffect } from 'react';
import config from './config.json';

// Auth Context 생성
const AuthContext = createContext();

// Auth Provider 컴포넌트
export function AuthProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);

  // 로컬 스토리지에서 로그인 상태 복원
  useEffect(() => {
    const savedAuth = localStorage.getItem('rubis_admin_auth');
    if (savedAuth === 'true') {
      setIsAdmin(true);
    }
  }, []);

  // 로그인 함수
  const login = (username, password) => {
    if (username === config.admin.username && password === config.admin.password) {
      setIsAdmin(true);
      localStorage.setItem('rubis_admin_auth', 'true');
      return true;
    }
    return false;
  };

  // 로그아웃 함수
  const logout = () => {
    setIsAdmin(false);
    localStorage.removeItem('rubis_admin_auth');
  };

  return (
    <AuthContext.Provider value={{ isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Auth Hook
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
